module.exports = __webpack_public_path__ + "img/banner5.49615691.jpg";